/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import {
    TextBlock,
    Stack,
    DividerNew as Divider,
    Alert,
    DisplayHtmlContent,
    Heading,
} from 'sarsaparilla';

import { NeedToKnowList } from 'shared-ui/components/NeedToKnowList/NeedToKnowList';
import {
    AnchorPageWithSidebarLayout,
    AnchorPageSection,
} from 'shared-ui/components/AnchorPageWithSidebarLayout';

export function FacilityInfoTab({
    alerts,
    needToKnowItems,
    directionsHtml,
    facilityName,
    address,
    phone,
}) {
    return (
        <AnchorPageWithSidebarLayout>
            <Stack space="lg">
                {!isEmpty(alerts) && (
                    <>
                        <AnchorPageSection heading="Alerts">
                            <Stack space="sm">
                                {alerts.map((item) => (
                                    <Alert key={item.body}>
                                        <DisplayHtmlContent html={item.body} />
                                    </Alert>
                                ))}
                            </Stack>
                        </AnchorPageSection>

                        <Divider />
                    </>
                )}

                {!isEmpty(needToKnowItems) && (
                    <>
                        <AnchorPageSection heading="Need To Know">
                            <NeedToKnowList listItems={needToKnowItems} />
                        </AnchorPageSection>

                        <Divider />
                    </>
                )}

                <AnchorPageSection heading="Directions">
                    <TextBlock data-notranslate>
                        <DisplayHtmlContent html={directionsHtml} />
                    </TextBlock>
                </AnchorPageSection>

                <Divider />

                <AnchorPageSection heading="Contact">
                    <TextBlock>
                        <Stack>
                            <Stack space="xxs">
                                <Heading headingLevel={3} appearance="small">
                                    Mailing address
                                </Heading>
                                <div data-notranslate>
                                    <div>{facilityName}</div>
                                    <div>{address.address1}</div>
                                    <div>{address.address2}</div>
                                    <div>{address.address3}</div>
                                    <div>
                                        {address.city}
                                        {!!address.city && ' '}
                                        {address.state_code}
                                        {!!address.state_code && ', '}
                                        {address.postal_code}
                                    </div>
                                </div>
                            </Stack>
                            <Stack space="xxs">
                                <Heading headingLevel={3} appearance="small">
                                    Phone number
                                </Heading>
                                <div>{phone}</div>
                            </Stack>
                        </Stack>
                    </TextBlock>
                </AnchorPageSection>
            </Stack>
        </AnchorPageWithSidebarLayout>
    );
}

FacilityInfoTab.propTypes = {
    alerts: PropTypes.arrayOf(
        PropTypes.shape({
            body: PropTypes.string,
            id: PropTypes.string,
        })
    ),
    needToKnowItems: PropTypes.array,
    directionsHtml: PropTypes.string,
    facilityName: PropTypes.string,
    address: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        address3: PropTypes.string,
        city: PropTypes.string,
        state_code: PropTypes.string,
        postal_code: PropTypes.string,
    }),
    phone: PropTypes.string,
};
